import { Checkbox as BaseCheckbox } from '@base-ui-components/react/checkbox'
import type { FC } from 'react'
import styles from './checkbox.module.css'

export interface CheckboxProps {
  checked?: boolean
  defaultChecked?: boolean
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void
  onCheckedChange?: (checked: boolean) => void
  disabled?: boolean
  name?: string
  value?: string
  color?: 'primary' | 'secondary' | 'default'
  size?: 'small' | 'medium'
  indeterminate?: boolean
  className?: string
  style?: React.CSSProperties
  id?: string
}

export const Checkbox: FC<CheckboxProps> = ({
  checked,
  defaultChecked,
  onChange,
  onCheckedChange,
  disabled,
  name,
  value,
  size = 'medium',
  indeterminate,
  className,
  style,
  id,
}) => {
  const iconSize = size === 'small' ? 20 : 24
  const classes = [styles.checkbox, className].filter(Boolean).join(' ')

  return (
    <BaseCheckbox.Root
      className={classes}
      style={style}
      checked={checked}
      defaultChecked={defaultChecked}
      disabled={disabled}
      indeterminate={indeterminate}
      name={name}
      id={id}
      onCheckedChange={c => {
        onCheckedChange?.(c as boolean)
        // Synthesize a change event for MUI-compatible onChange
        if (onChange) {
          const syntheticEvent = { target: { checked: c, name, value } } as React.ChangeEvent<HTMLInputElement>
          onChange(syntheticEvent)
        }
      }}
    >
      <BaseCheckbox.Indicator className={styles.indicator} keepMounted>
        <svg
          focusable="false"
          aria-hidden="true"
          viewBox="0 0 24 24"
          style={{ width: iconSize, height: iconSize, fill: 'currentColor' }}
        >
          {indeterminate ? (
            <path d="M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-2 10H7v-2h10v2z" />
          ) : (
            <path d="M19 3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-9 14l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z" />
          )}
        </svg>
      </BaseCheckbox.Indicator>
      <svg
        className={styles.unchecked}
        focusable="false"
        aria-hidden="true"
        viewBox="0 0 24 24"
        style={{ width: iconSize, height: iconSize, fill: 'currentColor' }}
      >
        <path d="M19 5v14H5V5h14m0-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z" />
      </svg>
    </BaseCheckbox.Root>
  )
}
